import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { Router } from '@angular/router';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DocumentActionType } from 'src/app/product-capture/model/enums/document-action-type.enum';
import { DOCUMENT_STATUS } from 'src/app/product-capture/model/enums/document-status.enum';
import { DocumentFile } from 'src/app/product-capture/model/interfaces/document-file.interface';
import { DocService } from 'src/app/product-capture/services/doc.service';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';
import { DocumentUtils } from '../../documents/document.utils';
import { DocDetails } from '../../documents/documents.model';

@Component({
  selector: 'app-document-menu',
  templateUrl: './document-menu.component.html',
  styleUrls: ['./document-menu.component.scss'],
})
export class DocumentMenuComponent implements OnInit {
  @Input() status: DOCUMENT_STATUS;
  @Input() doc: DocumentFile = null;
  @Input() rows: DocumentFile[] = [];
  @Output() doAction: EventEmitter<string> = new EventEmitter();
  faEllipsisV = faEllipsisV;
  actions = DocumentActionType;
  statuses = DOCUMENT_STATUS;
  previousDocument: DocumentFile | null;
  loading: boolean;

  constructor(
    private docService: DocService,
    private router: Router,
    private dcAlertService: DcAlertService
  ) { }

  @ViewChild('dropdown', { static: true }) dropdown: NgbDropdown;

  ngOnInit(): void {
    this.previousDocument = this.findPreviousDocument(this.doc, this.rows);
  }

  action(name: string): void {
    this.doAction.emit(name);
    this.dropdown.close();
  }

  findPreviousDocument(
    document: DocumentFile,
    rows: DocumentFile[]
  ): DocumentFile | null {
    //** rows are already sorted by date in fetchDocuments before being passed here */
    const index = rows.findIndex((obj) => obj.id === document.id);
    if (index === -1) {
      return null;
    } else {
      const previousValues = [...rows.slice(index + 1)];
      const previousValue = previousValues.find(
        (obj) => obj.language === document.language
      );
      return previousValue ? previousValue : null;
    }
  }

  compareWithPrevious() {
    this.docService
      .draftableGetArguments(this.doc.id, this.previousDocument.id)
      .pipe(
        catchError((error) => {
          this.dcAlertService.showAlert({
            type: 'danger',
            message: `An error occured, please try again`,
          });
          this.loading = false;
          this.dropdown.close();
          console.log(error);

          return throwError(error);
        })
      )
      .subscribe((data) => {
        this.loading = true;
        const docDetails1: DocDetails = DocumentUtils.getDocumentDetails(data[0], this.doc);
        const docDetails2: DocDetails = DocumentUtils.getDocumentDetails(data[1], this.previousDocument);

        this.docService.draftableGetLink(docDetails1, docDetails2, true).subscribe(
          ({ draftableUrl }) => {
            const base64Url = btoa(draftableUrl);
            const url = this.router.serializeUrl(
              this.router.createUrlTree([
                'product-capture/diff-pdf',
                this.docService.getFileName(this.doc.fileUrl),
                base64Url,
              ])
            );
            window.open(url, '_blank');
            this.loading = false;
            this.dropdown.close();
          },
          (error) => {
            this.dcAlertService.showAlert({
              type: 'danger',
              message: `An error occured, please try again`,
            });
            this.loading = false;
            this.dropdown.close();
            console.log(error);
          }
        );
      });
  }
}
